import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { UpdateNodeAsync } from "source/app/services/Workflows/ChangeData/UpdateNodeAsync";

export async function ToggleCollapsedAsync(node: IWorkflowNode) {
    const newValue = node.iscollapsed === undefined ? true : !node.iscollapsed;
    return UpdateNodeAsync(node, {iscollapsed:  newValue});
}
